import ImageIcon from '@mui/icons-material/Image';
import MicIcon from '@mui/icons-material/Mic';
import SendIcon from '@mui/icons-material/Send';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  Stack,
} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import { KeyboardEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type ChatFooterTextProps = {
  text: string;
  onChangeText: (text: string) => void;
  onSendMessage: (text: string, isSubUserSend?: boolean) => void;
  onSendImage: (isSubUserSend?: boolean) => void;
  onChangeToMic: () => void;
  isGuestTyping: boolean;
  dualLangTranslation?: boolean;
  canGuideControl?: boolean;
};

const ChatFooterText = (props: ChatFooterTextProps) => {
  const textMaxLength = 200;

  const sendMessage = () => {
    const value = props.text.trim();
    if (value !== '') {
      props.onSendMessage(
        value,
        props.isGuestTyping && props.dualLangTranslation
      );
      props.onChangeText('');
    }
  };

  // Enterで送信できるようにする
  const onPressEnter = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.nativeEvent.isComposing || e.key !== 'Enter') return;
    e.nativeEvent.preventDefault();
    sendMessage();
  };

  const { t } = useTranslation('chat');
  const boxShadow = '0px 0px 6px rgba(0, 0, 0, 0.2)';

  const [bgColor, setBgColor] = useState('white');
  useEffect(() => {
    if (!props.canGuideControl || !props.dualLangTranslation) return;
    setBgColor(props.isGuestTyping ? 'orange' : 'primary');
  }, [props.isGuestTyping, props.dualLangTranslation, props.canGuideControl]);

  return (
    <Stack
      width={1}
      boxShadow={boxShadow}
      zIndex={2}
      bgcolor={
        bgColor === 'primary'
          ? (theme) => theme.palette.primary.main
          : bgColor === 'orange'
          ? (theme) => theme.palette.orange.main
          : bgColor
      }
    >
      <Stack direction="row" px={2} py="13px">
        <IconButton
          onClick={() =>
            props.onSendImage(
              props.isGuestTyping &&
                props.canGuideControl &&
                props.dualLangTranslation
            )
          }
          sx={{ ml: -1 }}
        >
          <ImageIcon />
        </IconButton>
        <IconButton onClick={() => props.onChangeToMic()} sx={{ mx: -1 }}>
          <MicIcon />
        </IconButton>

        <FormControl
          fullWidth
          sx={{
            ml: 1,
            '& div.MuiInputBase-root': {
              borderRadius: '20px',
              // bgcolor: '#E5E9EB', // 入力欄の背景色。グレーっぽくて無効に見えてしまうのでとりあえず解除
            },
            '& .MuiInputLabel-shrink': {
              display: 'none!important',
            },
          }}
          variant="outlined"
        >
          <InputLabel
            htmlFor="outlined-adornment-password"
            size="small"
            sx={{ opacity: 0.7 }}
          >
            {t('menu.inputMessage')}
          </InputLabel>
          <OutlinedInput
            inputProps={{
              shrink: 'false',
              maxLength: textMaxLength,
              enterKeyHint: 'send',
            }}
            sx={{
              bgcolor: 'white',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor:
                  bgColor === 'orange'
                    ? (theme) => theme.palette.orange.main
                    : (theme) => theme.palette.primary.main,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor:
                  bgColor === 'orange'
                    ? (theme) => theme.palette.orange.main
                    : (theme) => theme.palette.primary.main,
              },
            }}
            size="small"
            id="chat-input-text-area"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => sendMessage()}
                  aria-label="toggle password visibility"
                  edge="end"
                  disabled={props.text.trim() === ''}
                >
                  <SendIcon
                    // color={props.text.trim() === '' ? undefined : 'primary'}
                    sx={{
                      color:
                        props.text.trim() === ''
                          ? undefined
                          : bgColor === 'orange'
                          ? (theme) => theme.palette.orange.main
                          : (theme) => theme.palette.primary.main,
                    }}
                  />
                </IconButton>
              </InputAdornment>
            }
            value={props.text}
            onChange={(ev) => props.onChangeText(ev.currentTarget.value)}
            onKeyDown={(e) => onPressEnter(e as any)}
          />
        </FormControl>
      </Stack>
    </Stack>
  );
};
export default ChatFooterText;
